const filters = [
  {
    title: "Expertise",
    optn1: "skin",
    optn2: "fertility",
    optn3: "heart",
    optn4: "ent",
    optn5: "gynecology",
  },
  {
    title: "Gender",
    optn1: "Male",
    optn2: "Female",
    optn3: "Neutral",
    optn4: "",
    optn5: "",
  },
  {
    title: "Fees",
    optn1: `₹499`,
    optn2: "₹999",
    optn3: "₹1599",
    optn4: "₹1999",
    optn5: "₹2599",
  },
  {
    title: "Languages",
    optn1: "Telugu",
    optn2: "English",
    optn3: "Tamil",
    optn4: "Hindi",
    optn5: "Kannada",
  },
];

const doctorsList = [
  {
    name: "Dr. Prerna Narang",
    image:
      "https://res.cloudinary.com/dgga8cymk/image/upload/v1713512817/Amrutam/Page-2/dr_prerna.png",
    id: "prerna1",
    rating: "4.5",
    specialty: "Male-Female Infertility",
    experience: "7 years of Experience",
    languages: "Speaks: English, Hindi, Marathi",
    videoFee: "800",
    chatFee: "Free",
  },
  {
    name: "Dr. Prerna Narang",
    image:
      "https://res.cloudinary.com/dgga8cymk/image/upload/v1713512817/Amrutam/Page-2/dr_prerna.png",
    id: "prerna1",
    rating: "4.5",
    specialty: "Male-Female Infertility",
    experience: "7 years of Experience",
    languages: "Speaks: English, Hindi, Marathi",
    videoFee: "800",
    chatFee: "Free",
  },
  {
    name: "Dr. Prerna Narang",
    image:
      "https://res.cloudinary.com/dgga8cymk/image/upload/v1713512817/Amrutam/Page-2/dr_prerna.png",
    id: "prerna1",
    rating: "4.5",
    specialty: "Male-Female Infertility",
    experience: "7 years of Experience",
    languages: "Speaks: English, Hindi, Marathi",
    videoFee: "800",
    chatFee: "Free",
  },
];

export { filters, doctorsList };
